/**
 * Brand / background image specs for CMS uploads (aligns with current UI slots).
 * Filenames are served from REACT_APP_S3_BASE_URL (same as projectBrandImage).
 */

export const BRAND_ASSET_SPECS = {
  /** Main header wordmark (left in Header / cards) */
  headerBrandLogo: {
    displaySlotPx: { maxWidth: { xs: 200, sm: 200, md: 276 }, maxHeight: 32 },
    objectFit: "contain",
    /** Recommended source (≈2× for retina) */
    recommendedSourcePx: { minWidth: 552, minHeight: 64 },
    aspectRatioHint: "Wide horizontal logo — ~8:1 wide:short; avoid tall stacked marks",
  },
  /** JV partner logo (terms.jvPartnerLogo → partnerHeaderImage, header when URL resolves) */
  headerPartnerLogo: {
    displaySlotPx: { maxHeight: { xs: 36, sm: 40, md: 75 } },
    objectFit: "contain",
    recommendedSourcePx: { minWidth: 200, minHeight: 150 },
    aspectRatioHint: "Transparent PNG; wide logo scales by height",
  },
  /** Full-page background (ApplicantCount, BookingJourneySelector, ThankYou modals) */
  pageBackground: {
    css: "background-size: cover; background-position: center",
    recommendedSourcePx: { width: 1920, height: 1080 },
    acceptableRangePx: {
      minWidth: 1600,
      minHeight: 900,
      maxWidth: 3840,
      maxHeight: 2160,
    },
    aspectRatioHint: "16:9 preferred; landscape — cover crops edges on narrow viewports",
  },
};

/**
 * @param {string} [filename] - Filename from API (e.g. brandLogo, projectBrandImage, jvPartnerLogo)
 * @param {string} [baseUrl] - Usually REACT_APP_S3_BASE_URL
 * @returns {string|null}
 */
export function resolveBrandCdnUrl(filename, baseUrl = process.env.REACT_APP_S3_BASE_URL) {
  if (!filename || !baseUrl) return null;
  const base = String(baseUrl).replace(/\/+$/, "");
  const path = String(filename).replace(/^\/+/, "");
  return `${base}/${path}`;
}
